import { Mail, Linkedin, MessageCircle } from "lucide-react";
import { STAGE_STYLE } from "@/lib/crmApi";

export const StageTag = ({ stage, testId }) => (
  <span data-testid={testId} className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold ${STAGE_STYLE[stage] || "bg-slate-100 text-slate-700"}`}>
    {stage}
  </span>
);

export const ProductTag = ({ name, testId }) => (
  <span data-testid={testId} className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-slate-900 text-white">{name}</span>
);

export const DieTag = ({ die, testId }) => (
  <span data-testid={testId} className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border border-violet-300 bg-violet-50 text-violet-800">
    Die · {die}
  </span>
);

const MODE_ICON = { Email: Mail, LinkedIn: Linkedin, WhatsApp: MessageCircle };

// Shows contact channels; preferred modes are highlighted.
export const ContactChannels = ({ contact, testPrefix }) => {
  if (!contact) return null;
  const modes = contact.modes || [];
  const wa = (contact.phone || "").replace(/[^\d+]/g, "").replace(/^\+/, "");
  const items = [
    { mode: "Email", value: contact.email, href: contact.email && `mailto:${contact.email}` },
    { mode: "LinkedIn", value: contact.linkedin && "LinkedIn", href: contact.linkedin && (contact.linkedin.startsWith("http") ? contact.linkedin : `https://${contact.linkedin}`) },
    { mode: "WhatsApp", value: contact.phone, href: wa && `https://wa.me/${wa}` },
  ].filter((i) => i.value || modes.includes(i.mode));
  return (
    <div className="flex flex-wrap gap-1.5">
      {items.map(({ mode, value, href }) => {
        const Icon = MODE_ICON[mode];
        const on = modes.includes(mode);
        const cls = `inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-full text-xs transition-colors ${
          on ? "bg-emerald-600 text-white font-semibold" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`;
        const body = <><Icon className="h-3.5 w-3.5" />{value || mode}</>;
        return href ? (
          <a key={mode} href={href} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}
            data-testid={`${testPrefix}-${mode.toLowerCase()}${on ? "-preferred" : ""}`} className={cls}>{body}</a>
        ) : (
          <span key={mode} data-testid={`${testPrefix}-${mode.toLowerCase()}${on ? "-preferred" : ""}`} className={cls}>{body}</span>
        );
      })}
    </div>
  );
};
